import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SystemDtoKeysEnum } from '@zaoblako/shared/modules/system/enums/system-dto-keys.enum';
import { semVerSchema } from '@zaoblako/shared/modules/serde/schemas/sem-ver.schema';
import { ChangelogDescriptionBlockDto, type ChangelogDescriptionBlockInterface } from '@zaoblako/shared/modules/system/dtos/changelog/changelog-description-block.dto';

import * as yup from 'yup';

/** Changelog message create and update APIs request body - DTO signature */
export interface ChangelogFormInterface {
  /** Application full version in SemVer format. Unique identifier of the changelog. */
  version: string;
  /** Publication datetime */
  publicationDate: Date;
  /**
   * Legacy single description (will be treated as a single "for all tariffs" block).
   * Prefer {@link descriptionBlocks}.
   */
  description?: string;
  /** Modularized blocks */
  descriptionBlocks?: ChangelogDescriptionBlockInterface[];
  /** Short summary of changelog */
  shortSummary: string;
}

/** Changelog message create and update APIs request body - DTO schema */
export const ChangelogFormDto = SerdeDtoClass.create<ChangelogFormInterface>(SystemDtoKeysEnum.CHANGELOG_FORM_DTO, {
  version: {
    label: 'Версия',
    serializer: semVerSchema,
  },
  publicationDate: {
    sortable: true,
    label: 'Дата публикации',
    serializer: yup.date(),
  },
  description: {
    optional: true,
    label: 'Текст сообщения (устар.)',
    serializer: yup.string(),
  },
  descriptionBlocks: {
    optional: true,
    label: 'Блоки описания',
    nested: ChangelogDescriptionBlockDto,
    serializer: (_, nested) => yup.array(nested),
  },
  shortSummary: {
    optional: true,
    label: 'Краткое описание',
    serializer: yup.string(),
  },
});
